exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.notes[data-v-e8c03bb0]{display:grid;grid-gap:30px\n}\n@media (min-width:60em){\n.notes[data-v-e8c03bb0]{grid-template-columns:1fr 2fr\n}\n}\n.notes li[data-v-e8c03bb0],.notes ul[data-v-e8c03bb0]{list-style:none;margin:0;padding:0\n}\n.notes ul[data-v-e8c03bb0]{overflow:scroll;white-space:nowrap\n}\n.notes li[data-v-e8c03bb0]{background:#f2f2f2;border-radius:5px;display:inline-block;margin:0 30px 0 0;max-width:400px;padding:15px;vertical-align:top\n}\n.notes li>*[data-v-e8c03bb0]{white-space:pre-wrap\n}\n.notes h3[data-v-e8c03bb0]{margin:0\n}\n.notes h4[data-v-e8c03bb0]{margin:0 0 10px\n}", ""]);

// exports
